import { SCHEDULE_MAX_DAYS_AHEAD, type ScheduledMessage } from "@ferrivia/api-contract";

export type WhenChoice = "3d" | "1w" | "2w" | "custom";

export const DEFAULT_REPLY_BY_DAYS = 7;
export const QUICK_PICK_DAYS: Record<Exclude<WhenChoice, "custom">, number> = { "3d": 3, "1w": 7, "2w": 14 };

export function messageText(message: Pick<ScheduledMessage, "body">): string {
  for (const block of message.body.blocks) {
    if ("text" in block && typeof block.text === "string") {
      return block.text;
    }
  }
  return "";
}

export function quickPickDate(days: number, now: Date): Date {
  const d = new Date(now);
  d.setDate(d.getDate() + days);
  d.setHours(9, 0, 0, 0);
  return d;
}

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

export function toDateInput(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function toTimeInput(d: Date): string {
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function parseLocal(date: string, time: string): Date | null {
  if (!date || !time) {
    return null;
  }
  const d = new Date(`${date}T${time}`);
  return Number.isNaN(d.getTime()) ? null : d;
}

export type SendAtProblem = "missing" | "past" | "tooFar";

export function sendAtProblem(sendAt: Date | null, now: Date): SendAtProblem | null {
  if (!sendAt) {
    return "missing";
  }
  if (sendAt.getTime() <= now.getTime()) {
    return "past";
  }
  if (sendAt.getTime() > now.getTime() + SCHEDULE_MAX_DAYS_AHEAD * 86_400_000) {
    return "tooFar";
  }
  return null;
}

export function addDays(d: Date, days: number): Date {
  const out = new Date(d);
  out.setDate(out.getDate() + days);
  return out;
}
